import { useRecoilState, useSetRecoilState } from "recoil";

import { baseTariffState, optionTariffState } from "@states/tariffs";
import {
    chosenTheftOptionState,
    insuranceState,
    isLegalCheckedState,
    isPackageCheckedState,
    isTheftCheckedState,
    securityDoorState,
    totalPriceState,
} from "@states/userData";

export function useStateUnsetter() {
    // Recoil setters
    const [chosenInsurance, setChosenInsurance] =
        useRecoilState(insuranceState);
    const setTotalPrice = useSetRecoilState(totalPriceState);
    const [isTheftChecked, setIsTheftChecked] =
        useRecoilState(isTheftCheckedState);
    const [isLegalChecked, setIsLegalChecked] =
        useRecoilState(isLegalCheckedState);
    const [isPackagedChecked, setIsPackageChecked] = useRecoilState(
        isPackageCheckedState,
    );
    const [chosenTheftOption, setChosenTheftOption] = useRecoilState(
        chosenTheftOptionState,
    );
    const [securityDoor, setSecurityDoor] = useRecoilState(securityDoorState);

    const setBaseTariff = useSetRecoilState(baseTariffState);
    const setOptionTariff = useSetRecoilState(optionTariffState);

    // Unset functions to export
    const unsetInsuranceChoiceState = () => {
        if (optionTariffState) setBaseTariff(undefined);

        if (chosenInsurance !== undefined) {
            setChosenInsurance(undefined);
            setTotalPrice(0);
            unsetAdditionalCoversState();
        }
    };

    const unsetAdditionalCoversState = () => {
        if (optionTariffState) setOptionTariff([]);

        if (isTheftChecked !== false) setIsTheftChecked(false);
        if (isLegalChecked !== false) setIsLegalChecked(false);
        if (isPackagedChecked !== false) setIsPackageChecked(false);
        if (chosenTheftOption !== "") setChosenTheftOption("");
        if (securityDoor !== "no-door") setSecurityDoor("no-door");
    };

    return {
        unsetInsuranceChoiceState,
        unsetAdditionalCoversState,
    };
}
